import * as React from 'react';

import { useTableContext } from '../../TableContext';
import { TableDateSection, TableDateSectionProps } from '../TableDateSection';
import { TableHeaderActions, TableHeaderActionsProps } from '../TableHeaderActions';

type TableActionsProps = {
  headerActionsProps?: TableHeaderActionsProps;
  dateSectionProps?: Partial<TableDateSectionProps>;
};

export function TableActions({ headerActionsProps, dateSectionProps }: TableActionsProps) {
  const { resetFilters } = useTableContext();

  const handleHeaderResetFilter = async () => {
    if (headerActionsProps?.onResetFilter) {
      headerActionsProps?.onResetFilter?.();
    } else {
      await resetFilters();
    }
  };

  return (
    <>
      {!!headerActionsProps?.showHeaderActions && (
        <TableHeaderActions {...headerActionsProps} onResetFilter={handleHeaderResetFilter} />
      )}
      {!!dateSectionProps && <TableDateSection dateTimeType="datetime" {...dateSectionProps} />}
    </>
  );
}
